module.exports = __webpack_public_path__ + "08_mustache_brown.c0ea3de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/08_mustache_brown.png
// module id = D57F
// module chunks = 0